import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { commonReducer, featureName } from '@rci/state-common-reducer';
import { EffectsModule } from '@ngrx/effects';
import { CommonEffects } from './services/state/state/common.effect';

// Only brand agnostic module and components belong here
// Never suppress schema errors in this module. If you are, you're doing something wrong
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(featureName, commonReducer),
    EffectsModule.forFeature([CommonEffects]),
  ],
  exports: [CommonModule],
})
export class RciCommonModule {}
